import type { Category } from './constants'

// 各類別的常用說明快選
const QUICK: Partial<Record<Category, string[]>> = {
  '小保養': ['機油＋機油芯', '機油', '空氣濾清器'],
  '大保養': ['大保養', '火星塞＋機油＋機油芯'],
  '耗材更換': ['前輪胎', '後輪胎', '前後輪胎', '煞車皮', '鏈條＋齒盤'],
  '驗車': ['定期檢驗'],
  '保險': ['強制險', '任意險'],
  '裝備': ['安全帽', '手套', '雨衣'],
}

interface Props {
  category: Category
  value: string
  onChange: (v: string) => void
}

export default function DescriptionInput({ category, value, onChange }: Props) {
  const quick = QUICK[category] ?? []

  return (
    <div className="field">
      <label htmlFor="description">項目說明（選填）</label>
      {quick.length > 0 && (
        <div className="quick-chips">
          {quick.map(q => (
            <button
              key={q}
              type="button"
              className={`chip${value === q ? ' active' : ''}`}
              onClick={() => onChange(value === q ? '' : q)}
            >
              {q}
            </button>
          ))}
        </div>
      )}
      <input
        id="description"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder="自由輸入"
        autoComplete="off"
      />
    </div>
  )
}
